import { usePackageHotelAvailabilityPage } from "@b2bportal/core-packages";
import { useModuleBEM } from "@b2bportal/core-themes";
import { AvailabilityPage } from "@tenant/hotels";
import { PackagesHotelSlotProvider } from "@tenant/packages";
import styles from "./PackageHotelAvailabilityPage.module.scss";
import { Benchmark } from "@/pages/Packages/components";
import { useValidatePackageRequiredHotelShopQueryParams } from "@/pages/Packages/pages/PackageHotelShopPage/hooks";

const PackageHotelAvailabilityPageContent = ({
  search,
}: {
  search: ReturnType<typeof useValidatePackageRequiredHotelShopQueryParams>;
}) => {
  const data = usePackageHotelAvailabilityPage({ search });
  const [block] = useModuleBEM(styles, "PackageHotelAvailabilityPage");

  return (
    <AvailabilityPage {...data} className={block}>
      <Benchmark />
    </AvailabilityPage>
  );
};

export const PackageHotelAvailabilityPageRoute = () => {
  // Use the RBC param hook instead of the core one so that infant URL params
  // (infants_on_lap, infants_in_seat) are parsed and forwarded to
  // initializePackages → fetchPackageSearchParams.
  const search = useValidatePackageRequiredHotelShopQueryParams();

  return (
    <PackagesHotelSlotProvider>
      <PackageHotelAvailabilityPageContent search={search} />
    </PackagesHotelSlotProvider>
  );
};
